import React, { useState, useEffect } from 'react';
import { ContextData, Token, User, UserForm } from '../../models/user';
import api, { apiFile, apiFileDownload } from '../../services/api';
import history from '../../routes/history';
import { AxiosResponse } from 'axios';
import { clearAllCibioConsultaFilters } from '../../util/authorizationsCIBIO/consultaFilters';

const emptySessionData: ContextData = {
    handleLogin: null,
    handleLogout: null,
    loading: true,
    user: {},
    token: {
        access_token: '',
        refresh_token: '',
        refresh_expires_in: ''
    }
};

export default function useAuth() {
    const [user, setUser] = useState<User>(emptySessionData.user);
    const [token, setToken] = useState<Token>(emptySessionData.token);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const refreshToken = localStorage.getItem('refresh_token');
        const refreshExpiresIn = localStorage.getItem('refresh_expires_in');

        if (token) {
            api.defaults.headers.Authorization = `Bearer ${token}`
            apiFile.defaults.headers.Authorization = `Bearer ${token}`
            apiFileDownload.defaults.headers.Authorization = `Bearer ${token}`

            setToken({
                access_token: token,
                refresh_token: refreshToken,
                refresh_expires_in: String(refreshExpiresIn)
            })
        }
        setLoading(false);
    }, [])

    const handleLogin = async ({ username, password }: UserForm): Promise<AxiosResponse> => {
        let response: any = null;
        try {
            const { data } = await api.post('api/v1/Login/Authenticate', {
                userName: username,
                senha: password,
            })

            clearAllCibioConsultaFilters();

            setToken(data);
            localStorage.setItem('token', data.access_token);
            localStorage.setItem('refreshToken', data.refresh_token);
            localStorage.setItem('refreshExpiresIn', data.refresh_expires_in);
            localStorage.setItem('tokenTimeCreated', data.created);
    
            api.defaults.headers.Authorization = `${data.token_type} ${data.access_token}`
            apiFile.defaults.headers.Authorization = `${data.token_type} ${data.access_token}`
            apiFileDownload.defaults.headers.Authorization = `${data.token_type} ${data.access_token}`
    
            history.push('/');
            response = data;

        } catch (error:any) {
            response = error.response;
        }

        return response;
    }

    const handleLogout = async () => {
        setToken({
            access_token: '',
            refresh_token: '',
            refresh_expires_in: ''
        });
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('refreshExpiresIn');
        localStorage.removeItem('tokenTimeCreated');
        clearAllCibioConsultaFilters();

        api.defaults.headers.Authorization = undefined;
        apiFile.defaults.headers.Authorization = undefined;
        apiFileDownload.defaults.headers.Authorization = undefined;

        history.push('/login');
    }

    return { user, loading, token, handleLogin, handleLogout };
}